import React from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Theme,
} from "@mui/material";
import { SortType } from "../../../../../models/SortType";
import { StyledTableRow } from "../../../../../styles/Shipmentstyles";
import AppTableHeaderCell from "../../../../../views/components/common/pages/AppTableHeaderCell";
import AppTableRowCell from "../../../../../views/components/common/pages/AppTableRowCell";
import { formatDate } from "../../../../../views/components/common/functions/formatDate";
import { OrderBasicDetails } from "../../../../../models/Order/OrderDetails";
import { useNavigate } from "react-router-dom";
import AppTablePagenation from "../../../../../views/components/common/pages/AppTablePagenation";

interface TableProps {
  data: OrderBasicDetails[];
  maxHeight?: number;
  minHeight?: number;
  limit: number;
  page_no: number;
  total_pages: number;
  total_count: number;
  sortBy?: string;
  sortType?: SortType;
  selectedShipmentIdsMap: Map<number, number>;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
  onSortChange?: (column: string, sortType: SortType) => void;
  selectAllItem: () => void;
  selectItem: (order: OrderBasicDetails) => void;
  deSelectAllItem: () => void;
  deSelectItem: (order: OrderBasicDetails) => void;
}

const OrderTable = ({
  data,
  maxHeight,
  page_no,
  limit,
  total_count,
  sortBy,
  sortType,
  minHeight = window.innerHeight - 350,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
}: TableProps) => {
  const theme = useTheme<Theme>();

  const navigate = useNavigate();

  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: maxHeight, minHeight: minHeight }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <AppTableHeaderCell
                minWidth="80px"
                sx={{
                  position: "sticky",
                  left: 0,
                  zIndex: 12,
                  backgroundColor: theme.palette.customColors.white,
                }}
                sortColumn={"id"}
                sortBy={sortBy}
                sortDirection={sortType}
                onSortChange={onSortChange}
                title="ORDER ID"
              />
              <AppTableHeaderCell title="CUSTOMER" minWidth="200px" />
              <AppTableHeaderCell title="USER NAME" />
              <AppTableHeaderCell
                title="PLACED ON"
                sortColumn={"created_date"}
                sortBy={sortBy}
                sortDirection={sortType}
                onSortChange={onSortChange}
              />
              <AppTableHeaderCell title="LABEL" />
              <AppTableHeaderCell title="AMOUNT" />
              <AppTableHeaderCell title="PLACED BY ADMIN" />
              <AppTableHeaderCell title="MODIFIED BY ADMIN" />
              <AppTableHeaderCell title="PROJECT" />
              <AppTableHeaderCell title="INVOICED" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item: OrderBasicDetails) => (
              <StyledTableRow key={item.id}>
                <AppTableRowCell
                  minWidth="80px"
                  sx={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    position: "sticky",
                    left: 0,
                    zIndex: 10,
                    backgroundColor: theme.palette.customColors.white,
                  }}
                  onClick={() =>
                    navigate(`/orders/add-orders?orderId=${item.id}`)
                  }
                >
                  {item.id}
                </AppTableRowCell>

                <AppTableRowCell
                  minWidth="300px"
                  sx={{
                    cursor: "pointer",
                    textDecoration: item.customer_id ? "underline" : "none",
                  }}
                  onClick={() => {
                    if (item.customer_id) {
                      navigate(
                        `/customers/add-edit-customer?customer-id=${item.customer_id}`
                      );
                    }
                  }}
                >
                  {item.customer_name || "-"}
                </AppTableRowCell>

                <AppTableRowCell>
                  {item?.user_first_name
                    ? `${item.user_first_name}${
                        item.user_last_name ? " " + item.user_last_name : ""
                      }`
                    : "-"}
                </AppTableRowCell>

                <AppTableRowCell>
                  {formatDate(item.created_date)}
                </AppTableRowCell>

                <AppTableRowCell>{item.label || "-"}</AppTableRowCell>

                <AppTableRowCell>{item.total_amount || "-"}</AppTableRowCell>

                <AppTableRowCell>
                  {item.creator_admin_name || "-"}
                </AppTableRowCell>

                <AppTableRowCell>
                  {item.editor_admin_name || "-"}
                </AppTableRowCell>

                <AppTableRowCell>
                  <span
                    style={{
                      display: "inline-block",
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: item.project_id ? "#00E0B3" : "#BD3078",
                      marginRight: "8px",
                    }}
                  ></span>
                  {item.project_id ? "Yes" : "No"}
                </AppTableRowCell>

                <AppTableRowCell>
                  <span
                    style={{
                      display: "inline-block",
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: item.invoiced ? "#00E0B3" : "#BD3078",
                      marginRight: "8px",
                    }}
                  ></span>
                  {item.invoiced ? "Yes" : "No"}
                </AppTableRowCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <AppTablePagenation
        fontSize="0.8rem"
        pageNo={page_no}
        limit={limit}
        totalCount={total_count}
        onPageChange={onPageChange}
        handleRowsChange={handleRowsChange}
      />
    </>
  );
};

export default OrderTable;
